import { CommonModule } from '@angular/common';
import {
  Component,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  OnInit,
  OnChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ButtonComponent } from '@mode/capra';
import { MatLegacyMenuModule } from '@angular/material/legacy-menu';

export interface RadioDropdownData {
  type: string;
  name: string;
}

@Component({
  standalone: true,
  imports: [CommonModule, MatLegacyMenuModule, ButtonComponent],
  selector: 'mode-radio-dropdown',
  templateUrl: './radio-dropdown.component.html',
  styleUrls: ['./radio-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioDropdownComponent implements OnInit, OnChanges {
  @Input() dropdownData: RadioDropdownData[] = [];
  @Input() placeholder = 'Loading...';
  @Input() selectedValue!: string;
  @Output() dropdownChange = new EventEmitter<string>();
  displayValue!: string;

  ngOnInit(): void {
    this.updateDisplayValue();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dropdownData'] || changes['selectedValue']) {
      this.updateDisplayValue();
    }
  }

  onSelectionChange(value: RadioDropdownData): void {
    this.displayValue = value.name;
    this.dropdownChange.emit(value.type);
  }

  private updateDisplayValue(): void {
    this.displayValue = this.dropdownData.find((item) => item.type === this.selectedValue)?.name || this.placeholder;
  }
}
